module.exports = __webpack_public_path__ + "static/media/solar-panel-roof.0590058d.webp";